module.exports = {
      id: "image-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#image-icon",
      toString: function () {
        return this.url;
      }
    }